import { createContext, useEffect, useReducer } from 'react';
const MetaModelUserContext = createContext();

const actionReducer = (state, action) => {
  switch (action.type) {
    case 'PUTDATA':
      return {
        ...state,
        ...action.payload,
      };
    case 'CLEARDATA':
      //   pneding
      return {
        ...state,
      };
    default:
      return state;
  }
};

const MetaModelUserProvider = ({ children }) => {
  const [userStepsDetail, dispatcher] = useReducer(actionReducer, {
    userCurrentStep: '',
    userCurrentData: null,
    userIsLoggedIn: false,
    isDataClear: true,
  });

  useEffect(() => {
    const userDetail = localStorage.getItem('metamodel:userDetail');
    if (userDetail) {
      dispatcher({
        type: 'PUTDATA',
        payload: JSON.parse(userDetail),
      });
    }
  }, []);

  return (
    <MetaModelUserContext.Provider value={{ ...userStepsDetail, dispatcher }}>
      {children}
    </MetaModelUserContext.Provider>
  );
};
export { MetaModelUserContext, MetaModelUserProvider };
